import type { QueryClient } from "@tanstack/react-query"
import { friendKeys, updateFriendInCache } from "@/entities/friend"
import { SCENARIOS_TOTAL } from "../model/constants"
import type { ScenarioPairState } from "../model/types"

export function syncFriendScenarios(
	queryClient: QueryClient,
	userId: number,
	friendId: number,
	scenarios: ScenarioPairState,
): void {
	let promotedToCircle = false

	updateFriendInCache(queryClient, userId, friendId, (friend) => {
		// A pair never plays fewer scenarios, so a lower counter means the
		// event is older than what we already show — applying it would put a
		// settled proposal back and re-block the chat until the next catch-up.
		if (scenarios.played < friend.scenarios.played) {
			return friend
		}

		promotedToCircle =
			scenarios.played >= SCENARIOS_TOTAL && friend.status !== "circle"

		return { ...friend, scenarios }
	})

	// `circle` never arrives over the wire: neither the accept response nor the
	// scenario events carry the friendship status, only GET /friends does.
	if (promotedToCircle) {
		queryClient.invalidateQueries({ queryKey: friendKeys.list(userId) })
	}
}
